import React, { Fragment } from 'react';
import ReactTooltip from 'react-tooltip';

const CheckboxWithTooltip = ({onChange, checked, id, tooltip}) => {
  return (
    <Fragment>
      <input 
        onChange={onChange}
        type="checkbox"
        checked={checked}
        data-for={id}
        data-place="top"
        data-tip={tooltip}
        onKeyDown={e => e.key === 'Enter' && onChange(e)}
      />
      <ReactTooltip id={id} />
    </Fragment>
  );
};

export default CheckboxWithTooltip;